import { FlightStatus } from '@fe/core';
import { FilterInfo } from '../flights/types';

export type RawRecord = {
    id: number;
    acid: string;
    origin: string | null | undefined;
    originPosition: [number, number];
    acType: string | null;
    depTime: number | null;
    status: FlightStatus;
    filterState: Record<number, FilterInfo>;
};

export type SheduledFlight = {
    id: number;
    acid: string;
    acType: string | null;
    depTime: number | null;
    status: FlightStatus;
};

export class ScheduledOrigin {
    private _name: string;
    private _position: [number, number];
    private _items: Map<number, SheduledFlight> = new Map();

    constructor(record: RawRecord) {
        if (!record.origin) {
            throw new Error('Null origin');
        }
        const { origin, originPosition } = record;
        this._name = origin;
        this._position = originPosition;
    }

    public get name(): string {
        return this._name;
    }

    public get position(): [number, number] {
        return this._position;
    }

    public get flights(): Iterable<SheduledFlight> {
        return this._items.values();
    }

    public get scheduled(): Iterable<SheduledFlight> {
        return this._items.values().filter((x) => x.status === FlightStatus.Scheduled);
    }

    public get planned(): Iterable<SheduledFlight> {
        return this._items.values().filter((x) => x.status === FlightStatus.Planned);
    }

    public get countSheduled(): number {
        return (this.scheduled as any).reduce((a: any) => a + 1, 0);
    }

    public get countPlanned(): number {
        return (this.planned as any).reduce((a: any) => a + 1, 0);
    }

    public get isEmpty(): boolean {
        return this._items.size === 0;
    }

    // Returns true if added;
    public addOrUpdate(record: RawRecord): boolean {
        const { id, acid, acType, depTime, status } = record;
        if (record.origin !== this.name) {
            return false;
        }

        let result: boolean;
        if (this._items.has(id)) {
            const item = this._items.get(id);
            item!.acType = acType;
            item!.acid = acid;
            item!.depTime = depTime;
            item!.status = status;
            result = false;
        } else {
            this._items.set(id, {
                id,
                acid,
                acType,
                depTime,
                status
            });
            result = true;
        }
        return result;
    }

    public remove(id: number) {
        this._items.delete(id);
    }
}
